import axios from 'axios'
import requesturl from './requesturl'
import userinterface from "./interfaces/userinterface";
import {EventBus} from "./eventbus";
import userroleinterface from "./interfaces/userroleinterface";

export default {

    data: () => ({
        token: null
    }),

    async login(username, pass, cb) {

        cb = arguments[arguments.length - 1];
        if (window.$cookies.get("token")) {
            if (cb) cb(true);
            this.onChange(true);
            return
        }

        await axios.post(requesturl() + "/api/latest/token",
            {
                username: username,
                password: pass
            }).then(async res => {
            if (!res.token) {
                this.token = res.data.token;
                window.$cookies.set('token', 'Bearer ' + res.data.token);
                if (cb) cb(true);
                this.onChange(true)
            } else {
                if (cb) cb(false);
                this.onChange(false)
            }

            await axios.get(requesturl() + "/api/latest/User/Rights", {headers: {Authorization: 'Bearer ' + res.data.token}})
                .then(res => {
                    window.$cookies.set("userRights", JSON.stringify(res.data));
                });

            let currentUser = null

            await userinterface.setCurrentUserInformation(res => {
                currentUser = res
                window.$cookies.set("currentUser", JSON.stringify(res))
            });

            await userroleinterface.getUserRolesForUser(currentUser.userId, userRoles => {
                let highestHierarchy = 0

                if (userRoles !== undefined && userRoles.length > 0) {
                    userRoles.forEach(userRole => {
                        if (highestHierarchy === 0) {
                            highestHierarchy = userRole.role.hierarchy
                        } else if (highestHierarchy > userRole.role.hierarchy) {
                            highestHierarchy = userRole.role.hierarchy
                        }
                    })
                }

                window.$cookies.set("highestUserRoleHierarchy", highestHierarchy)
            })
        }).catch(error => {

            let responseObj = {
                ok: false,
                status: error.response != null ? error.response.status : 503
            };

            cb(responseObj);
        });


    },

    getToken() {
        return window.$cookies.get("token");
    },

    logout(cb) {
        window.$cookies.remove("token");
        window.$cookies.remove("userRights");
        window.$cookies.remove("currentUser");
        window.$cookies.remove("highestUserRoleHierarchy");

        EventBus.$emit('userTokenExpired');
        EventBus.$emit('refreshNavigationBar');

        if (cb) cb();
        this.onChange(false)
    },

    loggedIn() {
        return !!window.$cookies.get("token");
    },

    onChange() {
    }
}



// WEBPACK FOOTER //
// ./src/auth.js